import { useQueryClient } from 'react-query';

import { ClaRequest } from 'generated/index';
import { mutations, queryKeys } from 'RestAPIs/rapini';
import showError from 'components/shared/showError';

export const useSaveCla = (props: { onSuccess: () => void }) => {
  const queryClient = useQueryClient();
  const { mutate: createCla, isLoading: isCreateLoading } =
    mutations.useCreateCla();
  const { mutate: updateCla, isLoading: isUpdateLoading } =
    mutations.useUpdateCla();

  // The CLA dropdowns elsewhere have their own cache entries under ['cla', ...]
  // (queries.ts and HolidaysSpecial/hooks/useGetClaData.ts), so a new or renamed
  // CLA would otherwise only reach them once those entries go stale.
  const onSuccess = () => {
    queryClient.invalidateQueries(queryKeys.getClas());
    queryClient.invalidateQueries(['cla']);
    props.onSuccess();
  };

  const mutate = (data: Partial<ClaRequest>) => {
    const payload: ClaRequest = {
      code: data.code!,
      name: data.name!,
      // An empty external code is left out, so a row whose cla_ext is NULL keeps
      // it instead of entering the import index under an empty key.
      externalCode: data.externalCode || undefined,
      isDefault: data.isDefault ?? false
    };

    if (!data.claId) {
      createCla(payload, {
        onSuccess,
        onError: (error) => showError(error)
      });
    } else {
      updateCla(
        {
          claId: data.claId,
          ...payload
        },
        {
          onSuccess,
          onError: (error) => showError(error)
        }
      );
    }
  };

  return {
    mutate,
    isLoading: isCreateLoading || isUpdateLoading
  };
};
